import { render, staticRenderFns } from "./SpecificWorkVe.vue?vue&type=template&id=1e06b577&"
import script from "./SpecificWorkVe.vue?vue&type=script&lang=js&"
export * from "./SpecificWorkVe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports